import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useHistory, useLocation } from 'react-router-dom';
import { useSelector, useDispatch } from 'react-redux';
import { adminCLientOrderDisplaySelector } from 'store/AdminClient/OrderDisplay';
import {
  fetchadminCLientOrderDisplay,
  fetchadminCLientOrderLineDisplay,
  fetchAdminClientTextOrderDisplay,
} from 'store/AdminClient/OrderDisplay/features';
import { removeOrder } from 'store/AdminClient/OrderList';
import {
  adminClientRedactionDataSelector,
} from 'store/AdminClient/RedactionData';

import axiosPrivate from 'config/axiosPrivate';
import { ORDERSTATUS } from 'utils/Constants';
import { verifyAllTextsDeletionCriteria } from 'helpers/OrderTextsHelper';
import { useWebsiteFilter } from 'utils/hooks/useWebsiteFilter';
import { formatDateShort } from 'utils/DateUtils';
import ProjectTextsTable from 'components/shared/projecttexttable/ProjectTextsTable';
import ProjectDetailsCard from 'components/shared/ProjectDetailsCard';
import RedactionModal from 'components/shared/Redactionmodal/RedactionModal';
import EnrichissementModal from 'components/shared/Redactionmodal/EnrichissementModal';
import YoutubeRedactionModal from 'components/shared/Redactionmodal/YoutubeRedactionModal';
import UpdateProjectModal from 'components/shared/updatedetailsproject/update';
import ProjectCreatedModal from 'components/shared/modal/ProjectCreatedModal';
import './ProjectDisplay.css';
import usePageTracking from 'utils/hooks/usePageTracking';

const ADMIN_CLIENT_PROJECT_DETAILS_PAGE = '/AdminClient/DetailsProject';

export default function ProjectDisplay() {
  usePageTracking(ADMIN_CLIENT_PROJECT_DETAILS_PAGE);

  const [isRedactionModalOpen, setIsRedactionModalOpen] = useState(false);
  const [isYoutubeModalOpen, setIsYoutubeModalOpen] = useState(false);
  const [isYoutubeAgent, setIsYoutubeAgent] = useState(false);
  const {
    order,
    status,
    textList,
    isTextLoading,
    isTextError,
    isLoading,
    isError,
  } = useSelector(adminCLientOrderDisplaySelector);

  const [isEnrichissementModalOpen, setIsEnrichissementModalOpen] = useState(false);
  const [isContentLimitModalOpen, setIsContentLimitModalOpen] = useState(false);

  const handleOpenRedactionModal = async () => {
    try {
      const normalizeUrl = (input) =>
        (input || '')
          .toString()
          .trim()
          .toLowerCase()
          .replace(/^https?:\/\//, '')
          .replace(/^www\./, '')
          .replace(/\/+$/, '');

      const selectedWebsiteNormalized = normalizeUrl(selectedWebsiteUrl);
      if (selectedWebsiteNormalized) {
        const { data: websitesData } = await axiosPrivate.get('/project/website/all');
        const websitesList = Array.isArray(websitesData) ? websitesData : [];
        const selectedWebsite = websitesList.find(
          (website) =>
            normalizeUrl(website?.urlSite || website?.url || website?.name) === selectedWebsiteNormalized
        );
        const websiteId = selectedWebsite?.id;

        if (websiteId) {
          const { data: websiteQuotas } = await axiosPrivate.get(`/project/website-quotas/${websiteId}`);
          const maxTexts = Number(websiteQuotas?.maxTexts);
          const usedTexts = Number(websiteQuotas?.usedTexts);
          const hasQuotaValues = Number.isFinite(maxTexts) && Number.isFinite(usedTexts);
          if (hasQuotaValues && (maxTexts - usedTexts) <= 0) {
            setIsContentLimitModalOpen(true);
            return;
          }
        }
      }
    } catch (error) {
      // On laisse l'ouverture du popin de création si les quotas ne sont pas récupérables.
    }

    console.log('Opening modal, contentType:', order?.contentType);

    if (order?.contentType === 'OPTIMIZE') {
      console.log('Opening enrichissement modal');
      setIsEnrichissementModalOpen(true);
    } else if (isYoutubeAgent) {
      console.log('Opening youtube modal');
      setIsYoutubeModalOpen(true);
    } else {
      console.log('Opening redaction modal');
      setIsRedactionModalOpen(true);
    }
  };

  const handleStatusChange = (textId, nextStatus) => {
    if (order?.id) {
      dispatch(fetchadminCLientOrderDisplay(order.id));
      dispatch(fetchAdminClientTextOrderDisplay(order.id));
    }
  };

  const handleCloseEnrichissementModal = () => {
    console.log('Closing enrichissement modal');
    setIsEnrichissementModalOpen(false);
  };

  const handleCloseYoutubeModal = () => {
    setIsYoutubeModalOpen(false);
  };
  const { redactions } = useSelector(adminClientRedactionDataSelector);
  const dispatch = useDispatch();
  const { t } = useTranslation();
  const history = useHistory();
  const location = useLocation();
  const [selectedWebsiteUrl] = useWebsiteFilter('AC_Dashboard_SelectedWebsite');

  const [title, setTitle] = useState('');
  const [areAllTextsDeletable, setAreTextsDeletable] = useState(false);

  const [searchValue, setSearchValue] = useState('');
  const [regenerateTextCommandeLoader, setRegenerateTextCommandeLoader] =
    useState(false);
  const [active, setActive] = useState(1);
  const [elementsPerPage, setElementsPerPage] = useState(10);
  const [confirmation, setConfirmation] = useState(false);
  const [confirmationMsg, setConfirmationMsg] = useState('');
  const [isDeleted, setIsDeleted] = useState(false);
  const [isSuccess, setIsSuccess] = useState(false);
  const [errorSuccess, setErrorSuccess] = useState(false);
  const [errorSuccessMsg, setErrorSuccessMsg] = useState('');
  const [isReload, setIsReload] = useState(false);
  const [jobStatus, setJobStatus] = useState('COMPLETED');
  const [isReloadingCompleted, setIsReloadingCompleted] = useState(false);
  const [faviconUrl, setFaviconUrl] = useState('');
  const [websiteDomain, setWebsiteDomain] = useState('');
  const [isDetailsOpen, setIsDetailsOpen] = useState(true);
  const [statusBanner, setStatusBanner] = useState(null);
  const [isUpdateProjectModalOpen, setIsUpdateProjectModalOpen] =
    useState(false);
  const [generationMessage, setGenerationMessage] = useState('');
  const [isGenerationError, setIsGenerationError] = useState(false);

  const fiveMinutesInMs = 1 * 30 * 1000;

  useEffect(() => {
    if (!statusBanner) return;
    const timeoutId = setTimeout(() => setStatusBanner(null), 2500);
    return () => clearTimeout(timeoutId);
  }, [statusBanner]);

  useEffect(() => {
    const fetchAgentContentType = async () => {
      const projectType = ((order?.type || '') + '').toUpperCase();
      if (!order?.aiAgentId || !projectType.startsWith('SMART')) {
        setIsYoutubeAgent(false);
        return;
      }

      try {
        const response = await axiosPrivate.get(`/smart-content/agent_ia/${order.aiAgentId}`);
        const agentType = String(
          response?.data?.typeContenu || response?.data?.contentType || ''
        ).toUpperCase();
        setIsYoutubeAgent(agentType === 'YOUTUBE');
      } catch {
        setIsYoutubeAgent(false);
      }
    };

    fetchAgentContentType();
  }, [order?.aiAgentId, order?.type]);

  useEffect(() => {
    document.title = t('Typix - Détails du projet');


    const previousBodyBg = document.body.style.backgroundColor;
    document.body.style.backgroundColor = '#FAFAFA';

    window.dispatchEvent(new Event('locationchange'));

    const urlParams = new URLSearchParams(window.location.search);
    let projectId = window.localStorage.getItem(
      'AdminClient_ProjectDisplay_id'
    );

    const urlCategory = urlParams.get('category');
    const storageCategory = window.localStorage.getItem(
      'AdminClient_ProjectDisplay_fromCategory'
    );
    const effectiveCategory = urlCategory || storageCategory;
    if (effectiveCategory) {
      try {
        window.sessionStorage.setItem(
          'AdminClient_ProjectDisplay_fromCategory',
          effectiveCategory
        );
      } catch { }
    }

    // Forcer le rechargement si l'ID du projet a changé
    if (projectId && projectId !== String(order?.id)) {
      console.log('Chargement du projet avec ID:', projectId);
      dispatch(fetchadminCLientOrderDisplay(projectId));
      dispatch(fetchadminCLientOrderLineDisplay(projectId));
      dispatch(fetchAdminClientTextOrderDisplay(projectId));
    }
    return () => {
      // Rétablir le background précédent au démontage
      document.body.style.backgroundColor = previousBodyBg;
    };
  }, [t, dispatch, order?.id, history, redactions, location.search]);

  useEffect(() => {
    const toDomain = (u) =>
      (u || '').replace(/^https?:\/\//i, '').replace(/\/.*$/, '').trim();

    if (!selectedWebsiteUrl) {
      setFaviconUrl('');
      setWebsiteDomain('');
      return;
    }

    const domain = toDomain(selectedWebsiteUrl);
    setWebsiteDomain(domain);

    if (!domain) {
      setFaviconUrl('');
      return;
    }

    const url = `https://www.google.com/s2/favicons?domain=${encodeURIComponent(
      domain
    )}&sz=64`;
    setFaviconUrl(url);
  }, [selectedWebsiteUrl]);

  const markGenerationInProgress = () => {
    setRegenerateTextCommandeLoader(true);
    try {
      window.localStorage.removeItem(`AC_Generation_${order.id}_error`);
      window.localStorage.setItem(`AC_Generation_${order.id}`, '1');
      window.dispatchEvent(new Event('ac-generation-changed'));
    } catch { }
  };

  const markGenerationFinished = ({ errorMessage } = {}) => {
    setRegenerateTextCommandeLoader(false);
    setIsReloadingCompleted(true);
    try {
      if (errorMessage) {
        window.localStorage.setItem(
          `AC_Generation_${order.id}_error`,
          errorMessage
        );
      } else {
        window.localStorage.removeItem(`AC_Generation_${order.id}_error`);
      }
      window.localStorage.setItem(`AC_Generation_${order.id}`, '0');
      window.dispatchEvent(new Event('ac-generation-changed'));
    } catch { }
  };

  const refreshProjectTexts = () => {
    dispatch(fetchadminCLientOrderLineDisplay(order.id));
    dispatch(fetchAdminClientTextOrderDisplay(order.id));
  };

  const buildGenerationFailedMessage = (jobs = []) => {
    const failedKeywords = jobs
      .filter(
        (job) =>
          String(job?.jobStatus || '').trim().toUpperCase() === 'FAILED'
      )
      .map((job) => job.keyword)
      .filter(Boolean);

    const failedKeywordsLine = failedKeywords.length
      ? `\n${t('Mots-clés en échec')} : ${failedKeywords.join(', ')}`
      : '';

    return `${t('La génération a échoué.')}${failedKeywordsLine}\n${t(
      'Veuillez vérifier vos données d’entrée et réessayer. Si le problème persiste, contactez le support.'
    )}`;
  };

  const fetchAndUpdate = async () => {
    if (!isLoading && !isError && !isDeleted && !isTextError && order?.id) {
      setTitle(order?.title || '');
    }

    if (
      !window.localStorage.getItem('AdminClient_ProjectDisplay_id') ||
      !order?.id ||
      order?.id != window.localStorage.getItem('AdminClient_ProjectDisplay_id')
    ) {
      return;
    }

    try {
      const response = await axiosPrivate.get(
        `/project/job-status/${order.id}`
      );
      const jobs = Array.isArray(response.data) ? response.data : [];

      // 202: au moins un keyword encore en PROCESSING → loading + polling
      if (response.status === 202) {
        markGenerationInProgress();
        refreshProjectTexts();
        return;
      }

      // 204: aucun job pour ce projet
      if (response.status === 204) {
        markGenerationFinished();
        return;
      }

      // 207: terminé avec au moins un keyword FAILED
      if (response.status === 207) {
        refreshProjectTexts();
        markGenerationFinished({
          errorMessage: buildGenerationFailedMessage(jobs),
        });
        return;
      }

      // 200: terminé, tous les keywords COMPLETED
      if (response.status === 200) {
        refreshProjectTexts();
        markGenerationFinished();
      }
    } catch (err) {
      console.error(err);
    }
  };

  useEffect(() => {
    fetchAndUpdate();

    const intervalId = setInterval(() => {
      fetchAndUpdate();
    }, fiveMinutesInMs);

    return () => clearInterval(intervalId);
  }, [isLoading, isError, isDeleted, order?.id]);

  useEffect(() => {
    const allDeletable = verifyAllTextsDeletionCriteria(textList);
    setAreTextsDeletable(allDeletable);
  }, [textList]);

  useEffect(() => {
    if (!order?.id) return;

    const generationStorageKey = `AC_Generation_${order.id}`;
    const generationEventName = 'ac-generation-changed';

    const syncFromStorage = () => {
      try {
        const val = window.localStorage.getItem(generationStorageKey);
        const errorMessage = window.localStorage.getItem(`${generationStorageKey}_error`);
        if (val === '1') {
          setIsGenerationError(false);
          const normalizedOrderTextType = ((order?.textType || '') + '').toUpperCase();
          const translationIndicators = new Set(['TRANSLATION', 'TRANSLATED', 'EDITORIAL_AND_TRANSLATION']);
          const isTranslationProject = translationIndicators.has(normalizedOrderTextType);

          if (isTranslationProject) {
            setGenerationMessage(t('Traduction en cours...'));
          } else if (order?.contentType === 'OPTIMIZE') {
            setGenerationMessage(t('Optimisation en cours...'));
          } else {
            setGenerationMessage(t('Génération en cours...'));
          }
        } else if (errorMessage) {
          setIsGenerationError(true);
          setGenerationMessage(errorMessage);
        } else {
          setIsGenerationError(false);
          setGenerationMessage('');
        }
      } catch {
        setIsGenerationError(false);
        setGenerationMessage('');
      }
    };

    syncFromStorage();

    const handler = () => syncFromStorage();
    window.addEventListener(generationEventName, handler);

    return () => {
      window.removeEventListener(generationEventName, handler);
    };
  }, [order?.id, order?.textType, order?.contentType, t]);

  const reloadTexts = () => {
    if (!order?.id) return;
    axiosPrivate
      .put(`/commands/restartChatGBTJob/${order.id}`)
      .then((res) => {
        setRegenerateTextCommandeLoader(true);
        setConfirmation(false);
      })

      .catch((err) => {
        console.log(err);
        setConfirmation(false);
      });
  };

  const deleteOrder = () => {
    if (!order?.id) return;
    axiosPrivate
      .delete(`/project/${order.id}`)
      .then(() => {
        try {
          setIsDeleted(true);
          setConfirmation(false);

          dispatch(
            removeOrder({ id: order.id, status: ORDERSTATUS.INPROGRESS })
          );

          setErrorSuccessMsg(t('Le projet a été supprimé avec succès !'));
          setIsSuccess(true);
          setErrorSuccess(true);

          setTimeout(() => {
            setErrorSuccess(false);
            history.push('/AdminClient/ProjectsEnCours');
            window.dispatchEvent(new Event('locationchange'));
          }, 1000);
        } catch (postSuccessErr) {
          history.push('/AdminClient/ProjectsEnCours');
        }
      })
      .catch((e) => {
        setIsDeleted(false);
        setIsSuccess(false);
        setConfirmation(false);
        setErrorSuccessMsg(t("Oups....! Une erreur s'est produite"));
        setErrorSuccess(true);
      });
  };

  const getRedirectPathForStatus = (s, projectType, fromCategory) => {
    if (fromCategory) {
      switch ((fromCategory || '').toUpperCase()) {
        case 'INPROGRESS':
          return '/AdminClient/ProjectsEnCours';
        case 'DELAYED':
          return '/AdminClient/ProjectsEnRetard';
        case 'VALID':
          return '/AdminClient/ProjectsValides';
        case 'NONATTRIBUTED':
          return '/AdminClient/ProjectsNonAttribuees';
        default:
          break;
      }
    }

    switch (s) {
      case ORDERSTATUS.INPROGRESS:
        return '/AdminClient/ProjectsEnCours';
      case ORDERSTATUS.DELAYED:
        return '/AdminClient/ProjectsEnRetard';
      case ORDERSTATUS.VALID:
        return '/AdminClient/ProjectsValides';
      case ORDERSTATUS.NONATTRIBUTED:
        return '/AdminClient/ProjectsNonAttribuees';
      default:
        break;
    }

    if (
      projectType === 'SMART' ||
      projectType === 'PREMIUM' ||
      projectType === 'SMART_WITH_REVIEW'
    ) {
      return '/AdminClient/AdminMainMenu';
    }

    return '/AdminClient/ProjectsEnCours';
  };

  const totalTextsCount = Array.isArray(textList) ? textList.length : 0;
  const onlineTextsCount = Array.isArray(textList)
    ? textList.filter((t) => t?.deployed).length
    : 0;
  const validatedTextsCount = Array.isArray(textList)
    ? textList.filter((t) => t?.validated && !t?.deployed).length
    : 0;
  const deliveredTextsCount = Array.isArray(textList)
    ? textList.filter((t) => t?.delivered && !t?.validated).length
    : 0;
  const draftTextsCount = Array.isArray(textList)
    ? textList.filter(
      (t) => !t?.delivered && !t?.validated && !t?.deployed
    ).length
    : 0;



  // Handler pour fermer la modal
  const handleCloseRedactionModal = () => {
    console.log('Closing redaction modal');
    setIsRedactionModalOpen(false);
  };

  return (
    <div className="project-display-page">
      <div className="project-display-breadcrumb-bar">
        <div className="project-display-breadcrumb-row">
          <button
            type="button"
            onClick={() => history.push('/AdminClient/ProjectsEnCours')}
            className="project-display-breadcrumb-button"
          >
            {t('Projet')}
          </button>
          <span> &gt; </span>
          <span>{selectedWebsiteUrl || ''}</span>
        </div>
      </div>

      <div className="project-display-header">
        <div className="project-display-header-left">
          <div className="project-display-title-row">
            <span className="project-display-title">
              {order?.title || ''}
            </span>

            {order?.type && (
              <span className="project-display-type-badge">
                {order.type}
              </span>
            )}

            {order?.id && totalTextsCount === 0 && (
              <button
                type="button"
                onClick={() => {
                  setConfirmation(true);
                  const projectName = order?.title || '';
                  setConfirmationMsg(
                    t(
                      'Êtes-vous sûr de vouloir supprimer le projet ? Cette action est irréversible.'),
                    { name: projectName }

                  );
                }}
                className="project-display-delete-button"
              >
                <img
                  src="/Images/icon-trash1.png"
                  alt="delete project"
                  className="project-display-delete-icon"
                />
              </button>
            )}
          </div>

          {websiteDomain && (
            <div className="project-display-website-row">
              <div className="project-display-website-icon-wrap">
                {faviconUrl ? (
                  <img
                    src={faviconUrl}
                    alt={websiteDomain}
                    className="project-display-website-favicon"
                  />
                ) : (
                  <span className="project-display-website-fallback">
                    {(websiteDomain[0] || 'W').toUpperCase()}
                  </span>
                )}
              </div>
              <div className="project-display-website-text-col">
                <span className="project-display-website-domain">
                  {websiteDomain}
                </span>
                {totalTextsCount > 0 && (
                  <span className="project-display-website-stats">
                    {t('{{online}} textes en lignes sur {{total}}', {
                      online: onlineTextsCount,
                      total: totalTextsCount,
                    })}
                  </span>
                )}
              </div>
            </div>
          )}
        </div>

        <button
          type="button"
          onClick={() => setIsUpdateProjectModalOpen(true)}
          className="project-display-edit-button"
        >
          <img
            src="/Images/edit-project-icon.png"
            alt="edit project"
            className="project-display-edit-icon"
          />
          <span>{t('Modifier le projet')}</span>
        </button>
      </div>

      {Array.isArray(textList) &&
        (isDetailsOpen ? (
          <div className="project-display-content-layout">
            <div className="project-display-main-column">
              <ProjectTextsTable
                texts={textList}
                onStatusChangeBanner={setStatusBanner}
                onNewContentClick={handleOpenRedactionModal}
                isDetailsOpen={isDetailsOpen}
                orderId={order?.id}
                generationMessage={generationMessage}
                isGenerationError={isGenerationError}
                orderTextAmount={order?.textAmount}
                totalTextsCount={totalTextsCount}
                onStatusChange={handleStatusChange}
              />

              {statusBanner && (
                <div className="project-display-status-banner project-display-status-banner-with-margin">
                  <div className="project-display-status-check">
                    ✓
                  </div>
                  <span>
                    {t('Statut modifié : {{status}}', { status: statusBanner })}
                  </span>
                </div>
              )}
            </div>

            <ProjectDetailsCard
              order={order}
              isOpen={isDetailsOpen}
              onToggle={setIsDetailsOpen}
              onlineTextsCount={onlineTextsCount}
              totalTextsCount={totalTextsCount}
              validatedTextsCount={validatedTextsCount}
              deliveredTextsCount={deliveredTextsCount}
              draftTextsCount={draftTextsCount}
            />
          </div>
        ) : (
          <div className="project-display-content-collapsed">
            <ProjectTextsTable
              texts={textList}
              onStatusChangeBanner={setStatusBanner}
              onNewContentClick={handleOpenRedactionModal}
              isDetailsOpen={isDetailsOpen}
              orderId={order?.id}
              generationMessage={generationMessage}
              isGenerationError={isGenerationError}
              orderTextAmount={order?.textAmount}
              totalTextsCount={totalTextsCount}
              onStatusChange={handleStatusChange}
            />

            {statusBanner && (
              <div className="project-display-status-banner project-display-status-banner-pill">
                <div className="project-display-status-check">
                  ✓
                </div>
                <span>
                  {t('Statut modifié : {{status}}', { status: statusBanner })}
                </span>
              </div>
            )}

            <div className="project-display-details-floating">
              <ProjectDetailsCard
                order={order}
                isOpen={isDetailsOpen}
                onToggle={setIsDetailsOpen}
                onlineTextsCount={onlineTextsCount}
                totalTextsCount={totalTextsCount}
                validatedTextsCount={validatedTextsCount}
                deliveredTextsCount={deliveredTextsCount}
                draftTextsCount={draftTextsCount}
              />
            </div>
          </div>
        ))}


      <RedactionModal
        isOpen={isRedactionModalOpen}
        onClose={handleCloseRedactionModal}
        orderId={order?.id}
        orderSiloName={order?.siloName}
        orderWebsite={selectedWebsiteUrl}
        language={order?.language}
        country={order?.website?.country || null}
        maxWords={order?.maxWords}
        orderType={order?.type}
        orderTextType={order?.textType}
        title={t('Créer un nouveau contenu')}
        aiAgentId={order?.aiAgentId}
        orderTextAmount={order?.textAmount}
        t={t}
        generationContext="AC"
      />
      <YoutubeRedactionModal
        isOpen={isYoutubeModalOpen}
        onClose={handleCloseYoutubeModal}
        orderId={order?.id}
        orderWebsite={selectedWebsiteUrl}
        language={order?.language}
        country={order?.website?.country || null}
        title={t('Créer un nouveau contenu')}
        aiAgentId={order?.aiAgentId}
        orderTextAmount={order?.textAmount}
        t={t}
        generationContext="AC"
      />
      <EnrichissementModal
        isOpen={isEnrichissementModalOpen}
        onClose={handleCloseEnrichissementModal}
        orderId={order?.id}
        orderSiloName={order?.siloName}
        orderWebsite={selectedWebsiteUrl}
        language={order?.language}
        country={order?.website?.country || null}
        maxWords={order?.maxWords}
        orderType={order?.type}
        orderTextType={order?.textType}
        title={t('Enrichir un contenu existant')}
        aiAgentId={order?.aiAgentId}
        orderTextAmount={order?.textAmount}
        t={t}
        generationContext="AC"
      />
      <UpdateProjectModal
        isOpen={isUpdateProjectModalOpen}
        onClose={() => setIsUpdateProjectModalOpen(false)}
        order={order}
        t={t}
        onUpdate={() => {
          if (order?.id) {
            dispatch(fetchadminCLientOrderDisplay(order.id));
            dispatch(fetchadminCLientOrderLineDisplay(order.id));
            dispatch(fetchAdminClientTextOrderDisplay(order.id));
          }
        }}
      />
      <ProjectCreatedModal
        isOpen={confirmation}
        onClose={() => setConfirmation(false)}
        onConfirm={deleteOrder}
        title={t('Supprimer le projet ?')}
        message={
          confirmationMsg ||
          t(
            'Êtes-vous sûr de vouloir supprimer ce projet ? Cette action est irréversible.'
          )
        }
        confirmButtonText={t('Supprimer')}
      />
      <ProjectCreatedModal
        isOpen={isContentLimitModalOpen}
        onClose={() => setIsContentLimitModalOpen(false)}
        onConfirm={() => history.push('/AdminClient/Forfait')}
        title={t('Limite de contenus atteinte')}
        message={t(
          'Vous avez atteint le nombre maximum de contenus inclus dans votre forfait. Passez à une offre supérieure pour continuer à créer et optimiser vos contenus.'
        )}
        confirmButtonText={t('Passer au forfait supérieur')}
        secondaryButtonText={t('Fermer')}
        onSecondaryAction={() => setIsContentLimitModalOpen(false)}
      />
    </div>
  );
}
